import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_GET_REACTIVATION_URL_DATA_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_GET_DOWNLOAD_AUTH_DETAILS_DATA_SUCCESS`;
export const getPhotoCaptureIntelligentReactivationUrlDataAction = (coCode, contextId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_REQUEST,
    payload: { coCode, contextId }
});
export const getPhotoCaptureIntelligentReactivationUrlDataSuccessAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_SUCCESS,
    payload: {}
});
//# sourceMappingURL=photoCaptureIntelligentReactivationUrlDetailsAction.js.map